// extracted by mini-css-extract-plugin
module.exports = {"container":"style_container__c3wwf","containerWithReviewCount":"style_containerWithReviewCount__5Zg0q"};